var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionHistory({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_action_history"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 12C19 15.866 15.866 19 12 19C10.2665 19 8.68024 18.3699 7.45765 17.3262L6.08564 18.784C7.6673 20.1641 9.73603 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12H0L4 17L8 12H5C5 8.13401 8.13401 5 12 5C15.866 5 19 8.13401 19 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 9V13.5352L14.4453 15.8321L15.5547 14.1679L13 12.4648V9H11Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionHistory);
export default __webpack_public_path__ + "static/media/ic_action_history.62f968465a854f8ba1a3c9f4e53ac237.svg";
export { ForwardRef as ReactComponent };